module.exports = __webpack_public_path__ + "static/media/avatar-4.79c28a62.png";